export const encodeText = (text: string) => {
    text = encodeURI(text);
    text = text.replaceAll("&", "%26");
    text = text.replaceAll("#", "%23");
    text = text.replaceAll("/", "%2F");
    text = text.replaceAll("?", "%3F");
    text = text.replaceAll("=", "%3D");
    text = text.replaceAll("!", "%21");
    text = text.replaceAll("$", "%24");
    return text;
}

export const decodeText = (text: string) => {
    return decodeURI(text);
}